import MuiSkeleton, { type SkeletonProps } from "@mui/material/Skeleton";

export type { SkeletonProps };

export function Skeleton(props: SkeletonProps) {
  return <MuiSkeleton {...props} />;
}
